// extracted by mini-css-extract-plugin
export var base = "_3r-0";
export var updateBanner = "_3r-1";